<template>
  <div class="card">
    <p @click="exit()" class="card_quit">
      <img src="../../../assets/img/quit_btn.png" alt="" />
    </p>
    <div class="card_exit" v-if="ShowExit">
      <div class="card_exit_box">
        <p class="card_exit_title">是否确认退出</p>
        <p class="card_exit_describle">退出后本次答题进度不保存</p>
        <div class="card_exit_btn">
          <button class="card_exit_btn_confirm" @click="toBack()">确认</button>
          <button class="card_exit_btn_fail" @click="exit(0)">取消</button>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="left" ref="leftDiv" @click="pre(mark)">
        <img :src="testImg" />
      </div>
      <div class="center" ref="centerDiv">
        <div class="content">
          <p class="ques f16">
            <span class="quesorder">{{ mark + 1 }}</span
            ><span class="content_ques">{{ item.description }}</span>
          </p>
          <div class="container content_text">
            <div
              v-for="(option, i) in item.option_list"
              :key="option.number"
              class="item"
              @click="updateAnswer($event, mark, i, option.score)"
              ref="btn"
            >
              <van-button class="btn">
                <div class="spanBox">
                  <span class="left_span">{{ indexArr[i] }}.</span
                  ><span class="right_span">{{ option.description }}</span>
                </div>
              </van-button>
            </div>
          </div>
        </div>
        <img :src="testImg" />
      </div>
      <div
        class="right"
        ref="rightDiv"
        @click="next(mark)"
        v-if="mark !== questionList.length - 1"
      >
        <img :src="testImg" class="bw" />
      </div>
    </div>
    <div class="bottom mb-20">
      <hr
        :style="'width:' + ((mark + 1) / questionList.length) * 100 + '%'"
        class="progress"
      />
      <hr
        :style="'width:' + (1 - (mark + 1) / questionList.length) * 100 + '%'"
        class="bg"
      />
      <p>
        <span class="blue f20">{{ mark + 1 }}</span
        >/{{ questionList.length
        }}<span class="fr mr-10 f14 gray">{{ testTime }}</span>
      </p>
      <van-button
        @click="submit()"
        v-if="mark === questionList.length - 1"
        class="smbtn"
      >
        确认提交</van-button
      >
      <div class="ChiceBtn f16">
        <div class="ChiceBox">
          <span class="leftArrow" @click="pre(mark)" ref="BackArrow">
            上一题
          </span>
          <span class="rightArrow" @click="next(mark)" ref="ForArrow"
            >下一题
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { store } from "./../../../store/index";
import { getTestDetail, submitComment } from "@/http/api";
import { Message, Loading } from "element-ui";
import Vue from "vue";
import { Swipe, SwipeItem, Toast } from "vant";
Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  name: "detail",
  data() {
    return {
      isActive: true,
      testTime: "00:00",
      selectedIndex: -1,
      ms: 0,
      s: 0,
      m: 0,
      h: 0,
      mark: 0,
      testImg: require("./../../../assets/img/test/testBg.png"),

      indexArr: ["A", "B", "C", "D", "E", "F"],
      questionList: [],
      answerList: [],
      selectedList: [],
      item: {},
      // 定时器
      animateTimeout: 0,
      nextTimeout: 0,
      ShowExit: false,
    };
  },
  methods: {
    exit(params) {
      if (params === 0) {
        this.ShowExit = false;
      } else {
        this.ShowExit = true;
      }
    },
    toBack() {
      this.$router.push("./../../index");
    },
    pre(index) {
      // console.log('start:', Date.now())
      // console.log(this.$refs)
      if (index !== 0) {
        // 更新题目
        console.log("这里回退", this.mark);
        this.mark--;
        this.item = this.questionList[this.mark];
        // 添加动效
        this.$refs.leftDiv.classList.add("animated", "slideInLeft");
        this.$refs.centerDiv.classList.add("animated", "slideInLeft");
        if (index !== this.questionList.length - 1) {
          this.$refs.rightDiv.classList.add("animated", "slideInLeft");
        }
        // 修改样式
        let option_i = this.selectedList[this.mark];
        this.$refs.btn.forEach((u, i) => {
          // console.log(u, i, option_i)
          if (i === option_i) {
            this.$refs.btn[i].firstElementChild.classList.remove("btn");
            this.$refs.btn[i].firstElementChild.classList.add("btnSelected");
          } else {
            this.$refs.btn[i].firstElementChild.classList.remove("btnSelected");
            this.$refs.btn[i].firstElementChild.classList.add("btn");
          }
        });
      }
      this.throttle(
        setTimeout(() => {
          // 移除动效
          this.$refs.leftDiv.classList.remove("animated", "slideInLeft");
          this.$refs.centerDiv.classList.remove("animated", "slideInLeft");
          if (index !== this.questionList.length - 1) {
            this.$refs.rightDiv.classList.remove("animated", "slideInLeft");
          }
        }, 1000),
        100000
      );
    },
    next(index) {
      // console.log('next', index, this.mark)
      // console.log(this.answerList[index])
      if (this.answerList[index] !== undefined) {
        if (index !== this.questionList.length - 1) {
          // 更新题目
          console.log("这里前进", this.mark);
          this.mark++;
          this.item = this.questionList[this.mark];
          // 修改样式
          let option_i = this.selectedList[this.mark];
          this.$refs.btn.forEach((u, i) => {
            // console.log(u, i, option_i)
            if (i === option_i) {
              this.$refs.btn[i].firstElementChild.classList.remove("btn");
              this.$refs.btn[i].firstElementChild.classList.add("btnSelected");
            } else {
              this.$refs.btn[i].firstElementChild.classList.remove(
                "btnSelected"
              );
              this.$refs.btn[i].firstElementChild.classList.add("btn");
            }
          });
          // 添加动效
          this.$refs.leftDiv.classList.add("animated", "slideInRight");
          this.$refs.centerDiv.classList.add("animated", "slideInRight");
          if (index !== this.questionList.length - 2) {
            this.$refs.rightDiv.classList.add("animated", "slideInRight");
          }
        }

        setTimeout(() => {
          // 移除动效
          console.log("这里是前进移除动效", this.mark);
          this.$refs.leftDiv.classList.remove("animated", "slideInRight");
          this.$refs.centerDiv.classList.remove("animated", "slideInRight");
          if (this.mark !== this.questionList.length - 1) {
            this.$refs.rightDiv.classList.remove("animated", "slideInRight");
          }
        }, 1000);
      } else {
        Message({ message: "请选择答案", type: "error" });
      }
    },
    timer() {
      //定义计时函数
      this.ms = this.ms + 50; //毫秒
      if (this.ms >= 1000) {
        this.ms = 0;
        this.s = this.s + 1; //秒
      }
      if (this.s >= 60) {
        this.s = 0;
        this.m = this.m + 1; //分钟
      }
      this.testTime = this.toDub(this.m) + ":" + this.toDub(this.s);
    },
    reset() {
      clearInterval(this.time);
      this.h = 0;
      this.m = 0;
      this.ms = 0;
      this.s = 0;
      this.testTime = "00:00";
    },
    start() {
      this.time = setInterval(this.timer, 50);
    },
    stop() {
      clearInterval(this.time);
    },
    toDub(n) {
      if (n < 10) {
        return "0" + n;
      } else {
        return "" + n;
      }
    },
    // 收集答案

    updateAnswer(e, ques_i, option_i, option_score) {
      window.clearTimeout(this.animateTimeout);
      // 样式修改
      this.$refs.btn.forEach((u, i) => {
        if (i === option_i) {
          this.$refs.btn[i].firstElementChild.classList.remove("btn");
          this.$refs.btn[i].firstElementChild.classList.add("btnSelected");

          window.clearTimeout(this.nextTimeout);
          if (this.$refs.leftDiv.classList.contains("animated")) {
            console.log("触发驳回");
            this.$refs.leftDiv.classList.remove("animated", "slideInRight");
            this.$refs.centerDiv.classList.remove("animated", "slideInRight");
            if (this.mark < this.questionList.length - 1) {
              this.$refs.rightDiv.classList.remove("animated", "slideInRight");
            }
          }
          console.log("移除动效", this.mark);
        } else {
          this.$refs.btn[i].firstElementChild.classList.remove("btnSelected");
          this.$refs.btn[i].firstElementChild.classList.add("btn");
        }
      });
      this.selectedList[ques_i] = option_i;
      this.answerList[ques_i] = option_score;
      if (ques_i < this.questionList.length - 1) {
        this.nextTimeout = window.setTimeout(() => {
          this.$refs.btn[option_i].firstElementChild.classList.remove(
            "btnSelected"
          );
          this.$refs.btn[option_i].firstElementChild.classList.add("btn");

          // 更新题目
          // console.log(this.mark)
          this.mark++;
          this.item = this.questionList[this.mark];
          console.log("我要更新", this.mark);
          // 添加动效
          console.log("添加动效");

          this.$refs.leftDiv.classList.add("animated", "slideInRight");
          this.$refs.centerDiv.classList.add("animated", "slideInRight");
          if (ques_i < this.questionList.length - 1) {
            this.$refs.rightDiv.classList.add("animated", "slideInRight");
          }
        }, 500);
      } else {
        // console.log(this.mark)
        this.item = this.questionList[this.mark];
      }
    },

    // 提交测评结果
    submit() {
      if (this.answerList[this.mark] !== undefined) {
        this.stop();
        let params = {
          appraisal_id: this.appraisal_id,
          items: {},
        };
        this.answerList.forEach((u, i) => {
          params.items[i + 1] = u;
        });
        console.log(params);
        submitComment(params).then((res) => {
          console.log(res);
          if (res.code === "SUCCESS") {
            this.$router.push("./result");
          } else {
            Message({ message: "提交失败，请重试", type: "error" });
          }
        });
      } else {
        Message({ message: "请选择答案", type: "error" });
      }
    },
    throttle(func, wait) {
      let previous = 0;
      return function () {
        let now = Date.now();
        let context = this;
        let args = arguments;
        if (now - previous > wait) {
          func.apply(context, args);
          previous = now;
        }
      };
    },
  },
  computed: {
    ...mapGetters(["user", "user_id", "eval_id", "appraisal_id"]),
  },
  created: function () {
    getTestDetail(this.eval_id).then((res) => {
      console.log("res", res);
      this.questionList = res.data.question_list;
      this.testImg = res.data.detail_image;
      this.item = this.questionList[this.mark];
      console.log("答应的结果", this.questionList, this.testImg, this.item);
    });
  },
  mounted: function () {
    this.start();
  },
};
</script>
<style lang="less" scoped>
@import "~Style/index.less";
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.card {
  width: 100%;
  margin-top: 40px;
  position: relative;
  .card_exit {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 30;
    .card_exit_box {
      .w(337);
      height: 207px;
      background: #fff;
      border-radius: 32px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      p {
        text-align: center;
      }
      .card_exit_title {
        font-size: 22px;
        margin-top: 38px;
      }
      .card_exit_describle {
        font-size: 12px;
        color: #9b9b9b;
        line-height: 22px;
      }
      .card_exit_btn {
        .w(302);
        margin: 23px auto 0;
        border-top: 1px solid #eaeaea;
        text-align: center;
        padding-top: 22px;
        button {
          .w(113);
          height: 45px;
          border-radius: 18px;
          font-size: 18px;
          text-align: center;
          line-height: 45px;
          border: none;
        }
        .card_exit_btn_confirm {
          background-color: #eceff5;
          color: #9b9b9b;
          margin-right: 18px;
        }
        .card_exit_btn_fail {
          color: #fff;
          background-color: #42686e;
        }
      }
    }
  }
  .container {
    display: flex;
    overflow: hidden;
    height: 100%;
    .left {
      .w(32);
      height: 381px;
      overflow: hidden;
      margin-top: 5%;
      border-radius: 0 0.48rem 0.48rem 0;
      img {
        height: 100%;
        opacity: 0.7;
        border: 1px solid #ededed;
      }
    }
    .right {
      .w(27);
      height: 381px;
      position: relative;
      border-radius: 0.48rem 0 0 0.48rem;
      img {
        height: 100%;
        border: 1px solid #ededed;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .magictime {
      -webkit-animation-duration: 1s;
      -moz-animation-duration: 1s;
      -o-animation-duration: 1s;
      animation-duration: 1s;
    }
  }
  .center {
    .w(290);
    height: 428px;
    margin-left: 11px;
    margin-right: 15px;
    -webkit-touch-callout: none; /*系统默认菜单被禁用*/
    -webkit-user-select: none; /*webkit浏览器*/
    -khtml-user-select: none; /*早期浏览器*/
    -moz-user-select: none; /*火狐*/
    -ms-user-select: none; /*IE10*/

    user-select: none;
    img {
      .w(290);
    }
    .content {
      width: 90%;
      margin-left: 5%;
      margin-top: 11%;
      .ques {
        margin-bottom: 0.5rem;
        line-height: 19px;
        font-weight: bolder;
        display: flex;
        > span {
          display: block;
        }
        .quesorder {
          width: 0.7rem;
        }
        .content_ques {
          flex: 1;
        }
      }
      .container {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        flex-direction: column;
        .item {
          width: 100%;
          margin-bottom: 0.32rem;
          span {
            line-height: 16px;
            text-align: start;
          }
        }
      }
    }
    img {
      height: 428px;
      position: absolute;
      top: 0px;
      opacity: 0.15;
      border: 1px solid #ededed;
      border-radius: 18px;
      z-index: -1;
    }
    .btn {
      width: 95%;
      border-radius: 18px;
      background-color: unset;
      border: 1px solid #d6d6d6;
    }
    .btnSelected {
      width: 95%;
      border-radius: 18px;
      background-color: #7487c3;
      border: none;
      color: white;
    }
  }
  .right {
    overflow: hidden;

    margin-top: 5%;
    img {
      height: 400px;
      border: 1px solid #ededed;
    }
  }
  .bottom {
    position: absolute;
    width: 90%;
    margin-left: 5%;
    margin-top: 22px;
    hr {
      display: inline-block;
    }
    .progress {
      background-color: #7487c3;
      height: 5px;
    }
    .bg {
      background-color: #eceff5;
      height: 5px;
    }
  }
  .smbtn {
    width: 90%;
    margin-left: 5%;
    border-radius: 18px;
    background-color: #7487c3;
    color: white;
    font-size: 20px;
    justify-content: center !important;
  }
  .van-button {
    justify-content: flex-start;
    padding: 0 0.6rem;
  }
  .spanBox {
    display: flex;
    width: 100%;
    .right_span {
      display: block;
    }
  }
  .ChiceBtn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .ChiceBox {
      width: 100%;
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 16px;
      }
    }
  }
}
.noShow {
  display: none;
}
.van-button::before {
  background-color: transparent;
  z-index: 10;
}
.card_quit {
  position: absolute;
  z-index: 10;
  left: 11%;
  transform: translateX(-25px);
  top: -27px;
}
</style>
<style>
[v-cloak] {
  display: none !important;
}
.el-carousel__arrow {
  display: none;
}
.magictime {
  animation-duration: 0.5s;
  animation-fill-mode: both;
}
</style>